import { useT } from '@hooks';
import React from 'react';

import s from './index.module.scss';
import PlanV2 from './planV2/planV2';
import { appStore } from '@store';

function Plan() {
	const { T } = useT();
	const { planV2 } = appStore.paymentStore.settings;

	return (
		<>
			{!planV2 ? (
				<div className={s.plan}>
					<h2 className={s.planTitle}>{T('personalized_plan')}</h2>
					<ul className={s.planList}>
						<li className={s.planListItem}>{T('mobile_app')}</li>
						<li className={s.planListItem}>{T('daily_programs')}</li>
						<li className={s.planListItem}>{T('audio_guided')}</li>
						<li className={s.planListItem}>{T('comprehensive_stats')}</li>
					</ul>
				</div>
			) : (
				<PlanV2 />
			)}
		</>
	);
}

export default Plan;
